export const iconFontAwesomeEmojiFaceGrinWink = (
	<i className="fa-solid fa-face-grin-wink"></i>
);
